// extracted by mini-css-extract-plugin
export default {"content":"privacy-policy_content__3ERVK"};